<template>
  <div>
    <div class="tab-title">我的视频</div>
    <ProfessionForm :mold="profession" />
    <div class="edit-video-container">
      <EditVideo />
    </div>
    <div class="feed-list-container" v-loading="feedShade">
      <VideoItem
        v-for="feed in feedList"
        :key="feed.id"
        :feed="feed"
        :page="feedPage"
      />
      <p class="no-feed" v-if="feedList.length == 0">{{ noFeedText }}</p>
    </div>
    <div class="pagination-wrapper">
      <el-pagination
        layout="prev, pager, next"
        :total="totalPage"
        prev-text="上一页"
        next-text="下一页"
        hide-on-single-page
        ref="pagination"
        @current-change="curtListPageClick"
      >
      </el-pagination>
      <!-- @prev-click="prevtListPageClick" @next-click="nextListPageClick" -->
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { apiMap } from "../../utils/apiMap";
import ProfessionForm from "../../components/user/storeroom/profession-form";
import EditVideo from "../../components/user/edit-video";
import VideoItem from "../../components/user/storeroom/video-item";
export default {
  name: "user-account",
  data() {
    return {
      profession: {
        name: "专业拍摄传记电影",
        title: "专业拍摄传记申请",
        type: 4,
      },
      feedShade: true,
      feedPage: 1,
      feedList: [],
      feedTotal: 0,
      noFeedText: "",
      AlbumID: 0,
    };
  },
  components: {
    ProfessionForm,
    EditVideo,
    VideoItem,
  },
  computed: {
    ...mapGetters(["userCenterSign"]),
    totalPage() {
      return this.feedTotal;
    },
  },
  mounted() {
    this.feedPage = this.userCenterSign.videoPage || 1;
    this.getVideoList(this.feedPage);
    this.$bus.$on("reload-video-list", this.reloadVideoList);
  },
  methods: {
    getVideoList(page) {
      let _this = this;
      _this.getListBtn = false;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["videoList"]["method"],
          url: apiMap["videoList"]["url"],
          params: {
            token: loginUser.token,
            start: page,
            count: 10,
            orderField: "created_at",
            order: "desc",
            type: 1,
          },
        })
        .then(function (response) {
          _this.feedShade = false;
          if (response.data.result.statusCode == 1) {
            _this.feedList = response.data.result.data;
            _this.feedTotal = response.data.result.count;
            _this.$refs.pagination.internalCurrentPage = page;
          } else {
            _this.noFeedText = "暂无视频";
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    prevtListPageClick(newPage) {
      //即将加载的起始页
      this.feedPage = newPage;
      this.getVideoList(newPage);
    },
    curtListPageClick(newPage) {
      //即将加载的起始页
      this.feedPage = newPage;
      this.getVideoList(newPage);
    },
    nextListPageClick(newPage) {
      this.feedPage = newPage;
      this.getVideoList(newPage);
    },
    reloadVideoList() {
      this.feedShade = true;
      this.feedTotal = 0;
      this.feedList = [];
      this.getVideoList(this.feedPage);
    },
  },
};
</script>
<style scoped>
.tab-title {
  height: 40px;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  line-height: 40px;
  letter-spacing: 2px;
  background-color: #1a70db;
}

.edit-video-container {
  width: 840px;
  padding: 10px 15px;
  margin-bottom: 10px;
  box-sizing: border-box;
  background-color: #fff;
}

.feed-list-container {
  min-height: 120px;
}

.no-feed {
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #fff;
}

.pagination-wrapper {
  margin-bottom: 15px;
  padding: 5px 0;
  text-align: center;
  background-color: #fff;
}

.pagination-wrapper:empty {
  padding: 0;
}
</style>